import React,{useState} from 'react'

import ClinicInfo from './info/ClinicInfo';
import Hours from './hours/Hours';
import RecallHours from './recall/RecallHours';
import ModernTabs from "../../../common/Tabs/ModernTabs";
import ClBrands from "./ClBrands";
import SocialLinks from "./SocialLinks";
import WebBooking from "./webbooking/WebBooking";
function TabCard() {
    const [activeTab, setActiveTab] = useState('general');
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };
    const TabContent = [
        {
            id:'general',
            label:'General',
            icon:'bi-house-door',
            content: <ClinicInfo/>
        },
        {
            id:'hours',
            label:'Hours',
            icon:'bi-clock',
            content: <Hours/>
        },
        {
            id:'recall-hours',
            label:'Recall Settings',
            icon:'bi-clock',
            content: <RecallHours/>
        },
        {
            id:'clbrands',
            label:'Contact Lens Brands',
            icon:'bi-eye',
            content: <ClBrands/>
        },
        {
            id:'social-links',
            label:'Social Links',
            icon:'bi-share',
            content: <SocialLinks/>
        },
        {
            id:'webbooking',
            label:'Web Booking',
            icon:'bi-globe2',
            content: <WebBooking/>
        }


    ]
  return (
        <div className="mt-2">
            <ModernTabs tabs={TabContent} orientation={"vertical"} />
        </div>




  )
}

export default TabCard